import { render } from "./FormDemo.vue?vue&type=template&id=262b159e"
import script from "./FormDemo.vue?vue&type=script&lang=js"
export * from "./FormDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__